import { createContext, useEffect, useState } from "react";

// Platforms
import { Api } from "../platforms/api";

// Utils
import { reformatAcfResponse } from "../utils/fetchUtils";
import { mapFiltersToTags } from "../utils/tagUtils";

export const TagsContext = createContext({});

export const TagsProvider = (props) => {
    const { children } = props;

    /************************************************
     * useState
     ************************************************/

    const [filters, setFilters] = useState([]);
    const [mappedFilters, setMappedFilters] = useState([]);
    const [selectedTags, setSelectedTags] = useState([]);
    const [selectedCategoryTags, setSelectedCategoryTags] = useState([]);
    const [selectedConferenceTags, setSelectedConferenceTags] = useState([]);
    const [tags, setTags] = useState([]);

    const hasSelectedCategoryTags = selectedCategoryTags?.length > 0;
    const hasSelectedConferenceTags = selectedConferenceTags?.length > 0;
    const hasSelectedTags = selectedTags?.length > 0;

    /************************************************
     * useEffect
     ************************************************/

    useEffect(() => {
        if (filters?.length && tags?.length) {
            setMappedFilters(mapFiltersToTags(filters, tags));
        }
    }, [filters, tags]);

    /************************************************
     * End Hooks
     ************************************************/

    // Filters

    /**
     * Fetch the filters that will be displayed in the "Filter By" section
     * of the header when visiting the Videos page
     */
    function fetchFilters() {
        Api.getFilters(onFetchFiltersSuccess, onFetchFiltersError);
    }

    function onFetchFiltersError(err) {
        console.error("filters err", reformatAcfResponse(err));
    }

    function onFetchFiltersSuccess({ headers, body: res }) {
        setFilters(reformatAcfResponse(res));
    }

    // Select Tags

    function addTag(tag, type) {
        setSelectedTags((prev) => [...prev, tag]);
        type === "categories" &&
            setSelectedCategoryTags((prev) => [...prev, tag]);
        type === "conferences" &&
            setSelectedConferenceTags((prev) => [...prev, tag]);
    }

    function clearTags() {
        setSelectedTags([]);
        setSelectedCategoryTags([]);
        setSelectedConferenceTags([]);
    }

    function removeTag(tag, type) {
        setSelectedTags((prev) =>
            prev.filter((selectedTag) => selectedTag.tag !== tag.tag)
        );
        type === "categories" &&
            setSelectedCategoryTags((prev) =>
                prev.filter((selectedTag) => selectedTag.tag !== tag.tag)
            );
        type === "conferences" &&
            setSelectedConferenceTags((prev) =>
                prev.filter((selectedTag) => selectedTag.tag !== tag.tag)
            );
    }

    // Tags

    function fetchTags() {
        Api.getTags(onFetchTagsSuccess, onFetchTagsError);
    }

    function onFetchTagsError(err) {
        console.error("fetch tags error", err);
    }

    function onFetchTagsSuccess({ headers, body: res }) {
        setTags(res);
    }

    const tagsContext = {
        addTag,
        clearTags,
        fetchFilters,
        fetchTags,
        filters,
        hasSelectedCategoryTags,
        hasSelectedConferenceTags,
        hasSelectedTags,
        mappedFilters,
        removeTag,
        selectedTags,
        selectedCategoryTags,
        selectedConferenceTags,
        tags,
    };

    return (
        <TagsContext.Provider value={tagsContext}>
            {children}
        </TagsContext.Provider>
    );
};
